import React, { useState } from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../../store';
import StockImagesSearch from '../../../common/StockImagesSearch';
import MediaPickersConstants from '../../../MediaPickersConstants';
import LogoStockImagesOrientationSelect from './LogoStockImagesOrientationSelect';

const LogoStockImagesSearch = (props) => {
    const [contextMenuAnchor, setContextMenuAnchor] = useState(undefined);

    const {
        logoStockImagesOrientation, 
        logoStockImagesSearchValue, setProperty, clearLogoStockImages, logoStockImages,
        logoStockImagesSearching, searchLogoStockImages, loadDefaultLogoStockImages 
    } = props;

    const disableClearButton = logoStockImagesSearchValue === "" && 
        logoStockImagesOrientation === MediaPickersConstants.STOCK_MEDIA_ORIENTATION.SQUARE && 
        logoStockImages.length == MediaPickersConstants.LOGO_STOCK_IMAGES_PER_PAGE;

    const onSearchValueChange = (event) => {
        setProperty('logoStockImagesSearchValue', event.target.value);
    };

    const loadLogoStockImages = (orientation) => {
        setProperty('logoStockImagesSearching', true);
        searchLogoStockImages(logoStockImagesSearchValue, (orientation || logoStockImagesOrientation), 1, MediaPickersConstants.LOGO_STOCK_IMAGES_PER_PAGE, () => {
            setProperty('logoStockImagesSearching', false);
        });
    };

    const clearResults = () => {
        setProperty('logoStockImagesSearchValue', '');

        const needClearOnlyInput  = logoStockImagesSearchValue !== "" &&
            logoStockImages.length == MediaPickersConstants.LOGO_STOCK_IMAGES_PER_PAGE;

        if(!needClearOnlyInput) {
            clearLogoStockImages();
            loadDefaultLogoStockImages();
        }
    }

    const onOrientationChange = (orientation) => {
        setContextMenuAnchor(undefined);
        loadLogoStockImages(orientation);
    }

    return (
        <StockImagesSearch
            clearResults={clearResults}  
            disableClearButton={disableClearButton}
            searchValue={logoStockImagesSearchValue}
            isSearching={logoStockImagesSearching}
            onSearchValueChange={onSearchValueChange}
            onSearchValueSubmit={loadLogoStockImages}
            setContextMenuAnchor={setContextMenuAnchor}
            contextMenuAnchor={contextMenuAnchor}
            stockImageOrientationSelect={<LogoStockImagesOrientationSelect onOrientationChange={onOrientationChange} />}
        />
    );
};

const mapStateToProps = (state) => {
    const {
        logoStockImages, 
        logoStockImagesOrientation,
        logoStockImagesSearchValue,
        logoStockImagesSearching
    } = state.mediaPicker;

    return {
        logoStockImages,
        logoStockImagesOrientation, 
        logoStockImagesSearchValue,
        logoStockImagesSearching
    };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const searchLogoStockImages = (keywords, orientation, pageNumber, itemsPerPage, callback) => dispatch(mediaPickerActions.searchLogoStockImages(keywords, orientation, pageNumber, itemsPerPage, callback));
    const clearLogoStockImages = () =>  dispatch(mediaPickerActions.clearLogoStockImages());
    const loadDefaultLogoStockImages = () => dispatch(mediaPickerActions.loadDefaultLogoStockImages());

    return { 
        setProperty,
        clearLogoStockImages,
        loadDefaultLogoStockImages,
        searchLogoStockImages
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogoStockImagesSearch);